export default {
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    permission: ['dashboard.accounts', 'Pull'],
    
  },
  {
    name: 'Validação Ato Isolado',
    url: '/dsr-validation',
    icon: 'icon-list',
    condition: (dsrPaymentMethod, dealerId) => dsrPaymentMethod === 2,
    permission: ['dashboard.accounts'],
    
  },
  {
    name: 'Submeter Resgate',
    url: '/emissao',
    icon: 'icon-calculator',
    condition: (dsrPaymentMethod, dealerId) => dsrPaymentMethod === 2,  // Custom condition
    permission: ['dashboard.accounts'],
  },
  {
    name: 'Entidade Patronal',
    url: '/entity_emission',
    icon: 'icon-calculator',
    condition: (dsrPaymentMethod, dealerId) => dsrPaymentMethod === 1,  // Custom condition
    permission: ['dashboard.accounts'],
  },
  {
    name: 'Pedidos de Resgate',
    url: '/pull',
    icon: 'icon-list',
    permission: ['Pull'],
    
  },
  {
    name: 'Gestão de Equipas',
    url: '/team_management',
    icon: 'icon-list',
    condition: (dsrPaymentMethod, dealerId, dsrType) =>  dsrType === 2 || dsrType === 3 || dsrType === 4,
    permission: ['dashboard.accounts'],
    
  },
  {
    name: 'Histórico de Resgates',
    url: '/pull-history',
    icon: 'icon-list',
    permission: ['Pull'],
    
  },
  {
    name: 'Validação Ato Isolado',
    url: '/year-validation',
    icon: 'icon-list',
    permission: ['Pull'],
    
  },
  {
    name: "Ativação Hellmann's",
    url: '/coupons',
    icon: 'icon-user'
  },
  {
    name: "Coupões Vila Galé",
    url: '/coupons_gale',
    icon: 'icon-user',
  },
  {
    name: 'Perfil',
    url: '/perfil', // Rota perfil
    icon: 'icon-user'
  },
  {
    name: 'Logout',
    url: '/logout', // Rota que cuidará do logout
    icon: 'icon-logout'
  },
  ]
};